import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Slim top progress bar visible during route changes so slow networks /
 * lazy chunks still feel responsive. Pure CSS, zero dependencies.
 */
export default function RouteTransitionBar() {
  const location = useLocation();
  const [phase, setPhase] = useState('idle'); // idle | run | done
  const firstRender = useRef(true);
  const timers = useRef([]);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    timers.current.forEach(clearTimeout);
    timers.current = [];
    setPhase('run');
    timers.current.push(setTimeout(() => setPhase('done'), 350));
    timers.current.push(setTimeout(() => setPhase('idle'), 800));
    return () => timers.current.forEach(clearTimeout);
  }, [location.pathname, location.search]);

  const width = phase === 'run' ? '70%' : phase === 'done' ? '100%' : '0%';
  const opacity = phase === 'idle' ? 0 : phase === 'done' ? 0 : 1;

  return (
    <div
      aria-hidden
      className="fixed top-0 left-0 h-[3px] z-[100] pointer-events-none bg-primary shadow-[0_0_10px_hsl(var(--primary)/0.6)] transition-[width,opacity] duration-500 ease-out"
      style={{ width, opacity }}
      data-testid="route-transition-bar"
    />
  );
}
